
import { Action             } from "@/models/action";
import { ActionType         } from "@/models/action.type";
import { Logger             } from "@/util/logger";
import {PanoramaContrastComponent} from "@/components/panorama.contrast.component";

export class ContrastResetAction extends Action {

  /** the panoramic controller that can actually do stuff for us */
  private _controller : PanoramaContrastComponent = null;

  /** standard constructor */
  constructor(controller : PanoramaContrastComponent) {
    super({
      key:   ActionType.CONTRAST_RESET,
      type:  ActionType.CONTRAST_RESET,
      label: 'Reset Contrast',
      icon:  '',
      tip:   ''
    });

    this._controller = controller;
  }

  /** fetch the panoramic controller */
  public controller(): PanoramaContrastComponent {

    return this._controller;
  }

  /** implement the action */
  public execute() : boolean {

    this._controller.reset();

    return true;
  }
}
